var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithubIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 261,
    viewBox: "0 0 261 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_301_8820)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.724,
    y: 36.5939,
    width: 180,
    height: 180,
    rx: 32,
    fill: "#1D1F23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.224,
    y: 37.0939,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.276 77.4224C102.666 77.4224 80.2761 99.8078 80.2761 127.423C80.2761 149.514 94.6027 168.256 114.469 174.868C116.968 175.331 117.886 173.783 117.886 172.463C117.886 171.27 117.839 167.331 117.818 163.153C103.907 166.178 100.972 157.254 100.972 157.254C98.6978 151.475 95.4207 149.938 95.4207 149.938C90.8844 146.835 95.7626 146.898 95.7626 146.898C100.784 147.251 103.427 152.051 103.427 152.051C107.887 159.695 115.124 157.485 117.978 156.208C118.426 152.976 119.722 150.77 121.152 149.522C110.046 148.257 98.3716 143.97 98.3716 124.811C98.3716 119.353 100.325 114.892 103.524 111.391C103.004 110.131 101.293 105.046 104.008 98.1585C104.008 98.1585 108.207 96.8146 117.761 103.284C121.75 102.176 126.027 101.62 130.276 101.602C134.526 101.62 138.806 102.176 142.802 103.284C152.346 96.8146 156.539 98.1585 156.539 98.1585C159.26 105.046 157.548 110.131 157.029 111.391C160.234 114.892 162.174 119.352 162.174 124.811C162.174 144.015 150.478 148.244 139.344 149.482C141.137 151.033 142.735 154.077 142.735 158.741C142.735 165.431 142.677 170.816 142.677 172.463C142.677 173.793 143.577 175.352 146.112 174.861C165.968 168.242 180.276 149.507 180.276 127.423C180.276 99.8078 157.89 77.4224 130.276 77.4224Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0028 148.649C98.893 148.897 98.5016 148.972 98.1459 148.801C97.7832 148.638 97.5793 148.299 97.6969 148.05C97.8048 147.794 98.1961 147.723 98.5581 147.895C98.9216 148.058 99.1286 148.399 99.0028 148.649ZM101.462 150.843C101.224 151.064 100.758 150.962 100.441 150.612C100.114 150.264 100.053 149.798 100.295 149.573C100.541 149.352 100.993 149.456 101.321 149.805C101.648 150.157 101.711 150.62 101.462 150.844L101.462 150.843ZM103.15 153.651C102.843 153.864 102.342 153.664 102.032 153.22C101.726 152.775 101.726 152.242 102.039 152.028C102.35 151.815 102.843 152.007 103.157 152.448C103.463 152.9 103.463 153.433 103.149 153.651L103.15 153.651ZM106.003 156.903C105.729 157.205 105.145 157.124 104.718 156.712C104.281 156.309 104.159 155.736 104.434 155.434C104.711 155.131 105.298 155.216 105.729 155.625C106.163 156.028 106.295 156.604 106.003 156.903H106.003ZM109.691 158.001C109.57 158.392 109.008 158.57 108.442 158.404C107.876 158.233 107.506 157.774 107.62 157.378C107.738 156.984 108.302 156.799 108.873 156.977C109.438 157.147 109.809 157.603 109.691 158.001H109.691ZM113.888 158.467C113.902 158.879 113.422 159.221 112.827 159.228C112.229 159.241 111.746 158.908 111.74 158.502C111.74 158.086 112.209 157.747 112.807 157.737C113.401 157.725 113.888 158.057 113.888 158.467ZM118.011 158.309C118.083 158.711 117.669 159.124 117.079 159.234C116.499 159.34 115.961 159.092 115.887 158.693C115.815 158.28 116.236 157.867 116.816 157.76C117.407 157.658 117.936 157.9 118.011 158.309Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_301_8820",
    x: 0.723999,
    y: 0.593872,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_301_8820"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_301_8820",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubIcon);
export default __webpack_public_path__ + "static/media/github_icon.fc4eb4c284026870cc47dd8ec36d1e93.svg";
export { ForwardRef as ReactComponent };